import React from 'react';
import { Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import ButtonLoader from '../../Layout/Buttons/ButtonLoader';
import { EngagementMeeting } from '../../../slices/marketplace/meetings/models/get-engagement-conference';
import {
    MeetingParticipantsTypesOptions,
    EngagementMeetingTypeHeaderColor,
    EngagementMeetingTypeBodyColor,
} from '../../../slices/marketplace/meetings/models/enums/meeting-participant-type.enum';
import { MeetingFormatTypesOptions } from '../../../slices/marketplace/meetings/models/enums/meeting-format.enum';
import { NotificationFlag } from '../../NotificationFlag/NotificationFlag';
import '../../../containers/PracticeManagementGroups/Conferences/Conferences.scss';

interface FinishedMeetingTileProps {
    engagementId: number;
    meeting: EngagementMeeting;
    onViewRecording(meeting: EngagementMeeting): void;
    onDownloadFile?(eventId: number, fileId: number): void;
    getNotificationFlagCode?(meeting: EngagementMeeting): string;
    isReadOnlyMode?: boolean;
}

const FinishedMeetingTile = (props: FinishedMeetingTileProps) => {
    const getNotificationFlag = () => {
        if (props.getNotificationFlagCode) {
            const flagCode = props.getNotificationFlagCode(props.meeting);
            return (
                <NotificationFlag
                    flagClassName="nf-flag"
                    eventCode={flagCode}></NotificationFlag>
            );
        }
        return null;
    };

    const getMeetingTypeLabel = () => {
        return MeetingParticipantsTypesOptions[props.meeting.participantsType] || 'Meeting';
    };

    const getMeetingFormatLabel = () => {
        return MeetingFormatTypesOptions[props.meeting.format] || 'Virtual';
    };

    const getHeaderColor = () => {
        return EngagementMeetingTypeHeaderColor[props.meeting.participantsType];
    };

    const getBodyColor = () => {
        return EngagementMeetingTypeBodyColor[props.meeting.participantsType];
    };

    return (
        <div
            className="conference-box"
            style={{
                backgroundColor: getBodyColor(),
            }}>
            {getNotificationFlag()}
            <div
                className="conference-header"
                style={{
                    backgroundColor: getHeaderColor(),
                }}>
                <div>{props.meeting.name}</div>
            </div>
            <div className="conference-info">
                <div>
                    <Row className="row-space">
                        <Col md={12}>
                            <div>
                                <span className="label-text">Meeting Type:</span>{' '}
                                {getMeetingTypeLabel()}
                            </div>
                        </Col>
                    </Row>
                    <Row className="row-space">
                        <Col md={12}>
                            <div>
                                <span className="label-text">Format:</span>{' '}
                                {getMeetingFormatLabel()}
                            </div>
                        </Col>
                    </Row>
                    <Row className="row-space">
                        <Col className="date-label" md={2}>
                            <div>
                                <span className="label-text">Start Date:</span>{' '}
                            </div>
                        </Col>
                        <Col md={2} className="date-value-text">
                            {props.meeting.dateStart ? moment(props.meeting.dateStart).format(
                                'MM/DD/YYYY'
                            ) : 'N/A'}
                        </Col>
                        <Col className="time-label" md={2}>
                            <div>
                                <span className="label-text">Start Time:</span>{' '}
                            </div>
                        </Col>
                        <Col md={2} className="time-value-text">
                            {props.meeting.dateStart ? moment(props.meeting.dateStart).format('h:mm A') : 'N/A'}
                        </Col>
                    </Row>
                    <Row className="row-space">
                        <Col className="date-label" md={2}>
                            <div>
                                <span className="label-text">End Date:</span>{' '}
                            </div>
                        </Col>
                        <Col md={2} className="date-value-text">
                            {props.meeting.dateEnd ? moment(props.meeting.dateEnd).format('MM/DD/YYYY') : 'N/A'}
                        </Col>
                        <Col className="time-label" md={2}>
                            <div>
                                <span className="label-text">End Time:</span>{' '}
                            </div>
                        </Col>
                        <Col md={2} className="time-value-text">
                            {props.meeting.dateEnd ? moment(props.meeting.dateEnd).format('h:mm A') : 'N/A'}
                        </Col>
                    </Row>
                    <Row className="row-space">
                        <Col md={12}>
                            <p className="label-text mb-2 mt-2">Participants:</p>
                            <p>
                                {props.meeting.participants.length
                                    ? props.meeting.participants
                                          ?.map((p) => p.name)
                                          .join(', ')
                                    : 'NA'}
                            </p>
                        </Col>
                    </Row>
                    <Row className="row-space">
                        <Col md={12}>
                            <p className="label-text mb-2 mt-2">Message:</p>
                            <p className="message">
                                {props.meeting.message}
                            </p>
                        </Col>
                    </Row>
                    {props.meeting.files?.length > 0 ? (
                        <Row>
                            <Col md={12}>
                                <p className="label-text mb-2">Documents:</p>
                            </Col>
                            {props.meeting.files.map((file, index) => {
                                return (
                                    <Col md={12} key={'file_' + index}>
                                        <p className="file">
                                            {file.name}{' '}
                                            {props.onDownloadFile && !props.isReadOnlyMode && (
                                                <FontAwesomeIcon
                                                    className="icon"
                                                    icon={faDownload}
                                                    onClick={() => {
                                                        props.onDownloadFile(
                                                            Number(
                                                                props.meeting.id
                                                            ),
                                                            file.id
                                                        );
                                                    }}></FontAwesomeIcon>
                                            )}
                                        </p>
                                    </Col>
                                );
                            })}
                        </Row>
                    ) : (
                        []
                    )}
                </div>

                <Row>
                    <Col md={6}>
                        {props.meeting.isRecordingAvailable && !props.isReadOnlyMode && (
                            <ButtonLoader
                                buttonText={'View Recording'}
                                loaderButtonText={''}
                                disabled={false}
                                isLoading={false}
                                onClick={() => {
                                    props.onViewRecording(props.meeting);
                                }}
                                className="btn btn-primary"></ButtonLoader>
                        )}
                    </Col>
                    {/* <Col md={6} className="removal-icon">
                        <div className="widget-content-left">
                            <div className="avatar-icon-wrapper">
                                <div className="avatar-icon">
                                    <FontAwesomeIcon
                                        className="trash-icon red"
                                        icon={faTrash}></FontAwesomeIcon>
                                </div>
                            </div>
                        </div>
                    </Col> */}
                </Row>
            </div>
        </div>
    );
};

export default FinishedMeetingTile;

